import { ResourceProps } from 'react-admin';
import icon from '@material-ui/icons/Eco';
import create from './create';
import edit from './edit';
import list from './list';

const responsibilityItems: ResourceProps = {
  name: 'responsibility-items',
  icon,
  options: { label: 'Responsabilidade social' },
  create,
  edit,
  list
};

export default responsibilityItems;
